/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_No_Results_BodyInputs */



/**
* | output |
* | --- |
* | "Try a different search term." |
*
* @param {Partner_Admin_No_Results_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_no_results_body = /** @type {((inputs?: Partner_Admin_No_Results_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_No_Results_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuchen Sie einen anderen Suchbegriff.")
	return /** @type {LocalizedString} */ ("Try a different search term.")
});